/**
 *
 * Asynchronously loads the component for ProfilePreview
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
